import { TooltipWrapper } from 'components/src/adminComponents/Tooltips/Tooltips';
import { StarIcon } from 'components/src/assets/svg';
import { Icon } from 'components/src/styles/styles';
import { Disclaimer } from 'components/src/styles/text';
import { lightTheme } from 'components/src/styles/theme';
import { FoodRating } from 'components/src/types/order.types';
import styled from 'styled-components';

/* The tooltip renders HTML and the comment is the customer's own words. */
const escapeHtml = (text: string) =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

/**
 * "★ 4" in an orders row: the customer's food rating, with the comment on
 * hover, drawn like the driver rating in the deliveries list. Under the name
 * on desktop; beside it on a phone card, whose height is fixed for the
 * virtualised list. Nothing until the order is rated.
 */
export const FoodRatingTag = ({
  rating,
  starSize = 16,
  besideName = false,
}: {
  rating?: FoodRating | null;
  /** 16 as in the deliveries list; the desktop row, under a name, takes 12. */
  starSize?: number;
  /**
   * On a heading's line: centred on its 22px line box the star sits ~2px
   * above the name's capitals, so it is let down to them.
   */
  besideName?: boolean;
}) => {
  if (!rating) return null;
  const comment = rating.comment?.trim();

  return (
    <TooltipWrapper
      tooltip={`Food rating: ${rating.rating}/5${
        comment ? `<br/>${escapeHtml(comment)}` : ''
      }`}
    >
      <Tag $besideName={besideName}>
        <Icon $size={starSize} color={lightTheme.yellow}>
          <StarIcon />
        </Icon>
        <Disclaimer $m="0" $mt="1">
          {rating.rating}
        </Disclaimer>
      </Tag>
    </TooltipWrapper>
  );
};

const Tag = styled.div<{ $besideName: boolean }>`
  position: relative;
  top: ${({ $besideName }) => ($besideName ? '2px' : '0')};
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 4px;
`;
